<div class="side-panel-backdrop" *ngIf="isOpen" (click)="closePanel()"></div>

<div class="side-panel" [class.open]="isOpen">
  <div class="side-panel-header">
    <h3>{{ title }}</h3>
    <button class="close-btn" type="button" (click)="closePanel()">×</button>
  </div>
  <div class="side-panel-body">
    <ng-content></ng-content>
  </div>
  <div class="side-panel-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
